module.exports = "/_next/static/images/0c77254dce6cd793f79eca9d032cc241-girl-holding-card-landing@xs.jpg.webp";